import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
} from "antd";

import dayjs from 'dayjs';
import { withTranslation } from 'react-i18next';

import * as DocumentActions from '@actions/ownerships';

class UpdateForm extends React.Component {
  static propTypes = {
    document: PropTypes.shape({
      id: PropTypes.number.isRequired,
      date: PropTypes.string,
      description: PropTypes.string,
    }),
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    confirmLoading: PropTypes.bool,
  }

  static defaultProps = {
    visible: false,
    confirmLoading: false,
  }

  constructor(props) {
    super(props);;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible && !this.props.visible) {
      this.props.form.resetFields();
      return
    }
  }

  renderForm() {
    const { document } = this.props;
    const formItemLayout = {
      labelCol: { span: 12 },
      wrapperCol: { span: 12 }
    };
    return (
      <Form form={this.props.form} layout="horizontal">
        <Form.Item
          label={ this.props.t("Properties.Property") }
          style={{ margin: 0, paddingBottom: 14 }}
          { ...formItemLayout }
        >
          { document.ownership_name }
          <br />
          { document.ownership_address }
        </Form.Item>
        <Form.Item
          label={ this.props.t("Documents.DocumentType") }
          style={{ margin: 0, paddingBottom: 14 }}
          { ...formItemLayout }
         name="doc_type" rules={[{
              required: true,
              message: `${ this.props.t("Documents.messages.Form.PleaseSelectDocumentType") }!`,
            }]} initialValue={document.type}>
          <Select
              style={{ width: '100%' }}
              placeholder={ this.props.t("Documents.messages.Form.PleaseSelectDocumentType") }
            >
              {
                Object.values(this.props.DocumentTypeOptions).sort((a, b) => (a.text.localeCompare(b.text))).map((docTypeOption) => (
                  <Select.Option
                    key={ docTypeOption.value }
                  >
                    { docTypeOption.text }
                  </Select.Option>
                ))
              }
            </Select>
        </Form.Item>
        <Form.Item
          label={ this.props.t("Documents.DocumentName") }
          style={{ margin: 0, paddingBottom: 14 }}
          { ...formItemLayout }
         name="doc_name" rules={[
              { required: false, message: `${ this.props.t("Documents.messages.Form.PleaseInputDocumentName") }!` },
            ]} initialValue={document.doc_name}>
          <Input />
        </Form.Item>
        <Form.Item
          label={ this.props.t("Documents.DocumentDate") }
          style={{ margin: 0, paddingBottom: 14 }}
          { ...formItemLayout }
         name="date" rules={[
              { required: false, message: `${ this.props.t("Documents.messages.Form.PleaseSelectDocumentDate") }!` },
            ]} initialValue={document.date ? dayjs(document.date) : null}>
          <DatePicker format={"YYYY/MM/DD"} />
        </Form.Item>
        <Form.Item
          label={ this.props.t("shared.Description") }
          style={{ margin: 0, paddingBottom: 14 }}
          { ...formItemLayout }
         name="description" rules={[
            ]} initialValue={document.description}>
          <Input.TextArea rows={ 4 } placeholder={ this.props.t("shared.Description") } />
        </Form.Item>
      </Form>
    )
  }

  render() {
    const { document } = this.props;
    if (!document) {
      return null;
    }

    return (
      <Modal
        visible={ this.props.visible }
        title={ this.props.t("Documents.actions.EditDocument") }
        okText={ this.props.t("actions.Submit") }
        onCancel={ this.props.onCancel }
        onOk={ this.props.onOk }
        confirmLoading={ this.props.confirmLoading }
      >
        { this.renderForm() }
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    DocumentTypeOptions: state.documentsReducer.DocumentTypeOptions,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  };
}

const ConnectedUpdateForm = connect(mapStateToProps, mapDispatchToProps)(UpdateForm);

const WrappedUpdateForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <ConnectedUpdateForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUpdateForm);
